import styled from "styled-components";
import { Box, colors } from "@mui/material";

export const PricingWrapper = styled(Box)`
	display: flex;
	gap: 20px;
	padding: 15px 0 24px;

	@media (max-width: 600px) {
		flex-direction: column;
	}
`;

export const PricingCard = styled(Box)<{ $selected?: boolean; $signature?: boolean }>`
	flex: 1;
	border-radius: 16px;
	border: 2px solid
		${({ $selected, $signature }) => ($selected ? ($signature ? "#C9A84C" : "#789DBC") : colors.grey[200])};
	padding: 25px 24px;
	cursor: pointer;
	position: relative;
	transition:
		border-color 0.2s,
		box-shadow 0.2s;
	background: ${({ $selected, $signature }) => ($selected ? ($signature ? "#FFFBF0" : "#F0F7FF") : "#fff")};
	box-shadow: ${({ $selected }) => ($selected ? "0 4px 20px rgba(0,0,0,0.08)" : "none")};
	display: flex;
	flex-direction: column;
	&:hover {
		border-color: ${({ $signature }) => ($signature ? "#C9A84C" : "#789DBC")};
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
	}
`;

export const PricingHeader = styled(Box)`
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 8px;
`;

export const PriceAmount = styled(Box)`
	display: flex;
	align-items: baseline;
	gap: 4px;
	margin-bottom: 4px;
	position: relative;
	.old_price {
		font-size: 14px;
		position: absolute;
		top: -25px;
		&:before {
			position: absolute;
			top: 50%;
			content: "";
			height: 1px;
			width: 100%;
			background: ${({ theme }) => theme.palette.text.primary};
		}
	}
`;

export const FeatureList = styled(Box)`
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-top: 20px;
	padding-top: 20px;
	border-top: 1px solid ${colors.grey[100]};
`;

export const FeatureItem = styled(Box)`
	display: flex;
	align-items: flex-start;
	gap: 10px;
	font-size: 14px;
	color: ${colors.grey[700]};
	line-height: 1.4;
`;

export const DiscountBadge = styled(Box)`
	position: absolute;
	top: 16px;
	right: -8px;
	background: ${colors.deepOrange[600]};
	color: #fff;
	font-size: 14px;
	font-weight: 700;
	padding: 4px 10px;
	border-radius: 0 6px 6px 0;
	z-index: 2;
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
`;

export const SelectedIndicator = styled(Box)<{ $signature?: boolean }>`
	position: absolute;
	top: -1px;
	right: 18px;
	width: 24px;
	height: 24px;
	border-radius: 50%;
	background: ${({ $signature }) => ($signature ? "#C9A84C" : "#789DBC")};
	display: flex;
	align-items: center;
	justify-content: center;
	transform: translateY(-50%);
`;
